<template>
  <div class="document">
    <div class="header">
      <EsHeader>
        <template #header>
          <div class="header-title">
            Data Mart Synchronization Details
          </div>
        </template>
      </EsHeader>
    </div>
    <div class="is-flex flex-justify--end flex-align--center" style="margin-right: 1rem; padding-bottom: 2rem">
       <div style="text-align: right;">
          <p style="margin-left: 2rem;">The Re-Synchronization request has been submitted successfully and is in progress.</p>
          <p style="margin-right: 10.7rem;">This process may take several minutes or more to complete.</p>
        </div>
      <div style="margin-left: auto;">
        <button class="button is-primary" @click.prevent="goBackToAllDataMarts()">
          Return to Data Mart List
        </button>
      </div>
    </div>
  </div>
</template>



<script>
import EsHeader from '@/components/EsHeader.vue';
export default {
  components: {
    EsHeader,
  },
  methods: {
    goBackToAllDataMarts() {
      this.$emit('dataMartList');
    },
  },
};
</script>

<style lang="sass" scoped>
  .header
    display: flex
    align-items: center
  .text
    text-align: center
    font-size: 14px
</style>
